// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"679":"d0f9d1a8","734":"43653964","917":"5a235143"}[chunkId] + ".chunk.js";
};